import SimpleMdeReact from "react-simplemde-editor";
import { Col, Label } from "reactstrap";
import { P } from "../../../../../../AbstractElements";
import { ToolbarBoxProp } from "../../../../../../Types/ECommerce.type";

export default function ToolbarBox({ label, paragraph }: ToolbarBoxProp) {
  const mdeEditorText = `Enter your messages...`;
  return (
    <Col xs={12}>
      {label && (
        <Col xs={12}>
          <Label>{"Additional Description"}</Label>
        </Col>
      )}
      <div className="toolbar-box">
        <SimpleMdeReact id="editor_container" placeholder={mdeEditorText} options={{ autofocus: false, spellChecker: true }} />
      </div>
      <P>{paragraph}</P>
    </Col>
  );
}
